import React, { useEffect } from "react"
import { graphql } from "gatsby"

import Layout from "../components/layout"
import Seo from "../components/seo"

import Section from "../components/section"
import ContactUs from "../components/homepage/contact-us"
import ContactHero from "../components/contact/contact-hero"
import { getPrismicText } from "../services/getPrismicText"

const ContactPage = ({ data }) => {
  const siteCopies = data?.allPrismicHomepage?.nodes[0]?.dataRaw
  const footerData = data?.allPrismicFooter?.nodes[0]?.dataRaw

  useEffect(() => {
    if (typeof window !== "undefined") {
      window.scrollTo(0, 0)
    }
  }, [])

  return (
    <Layout footerData={footerData} noHero activeSection="contact">
      <Seo title="Contact Us" />
      <div id="contact">
        <ContactHero
          heading={getPrismicText(siteCopies, "contact_us_header")}
          backgroundImageUrl={siteCopies?.contact_us_page_image?.url}
        />
        <Section id="contact">
          <ContactUs data={siteCopies} showSubtitle />
        </Section>
        {/* <FeaturedProducts data={siteCopies} /> */}
      </div>
    </Layout>
  )
}

export default ContactPage

export const data = graphql`
  query {
    allPrismicHomepage {
      nodes {
        dataRaw
      }
    }

    allPrismicFooter {
      nodes {
        dataRaw
      }
    }
  }
`
